import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { ExcelService } from 'src/app/services/excel.service';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
  selector: 'app-professionals',
  templateUrl: './professionals.component.html',
  styleUrls: ['./professionals.component.scss']
})
export class ProfessionalsComponent implements OnInit {

  public users: [];
  public showAllUsers: boolean;
  public selectedUser: any;
  public userDetail: boolean;
  public professionalsUsers = [
    { firstName: "A", lastName: "b", firm: "ABC Financials", email: "test@test.com", active: "active", license: "Yes" }
  ]

  constructor(private router: Router, public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private excelService: ExcelService, public themeService: ThemeService) { }

  ngOnInit() {
    this.showAllUsers = true
  }

  onSelect(dataUser) {
    this.showAllUsers = false;
    this.selectedUser = dataUser
    this.userDetail = true
  }

  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.users, 'Users');
  }

  backFromDetailUser() {
    this.showAllUsers = true
    this.userDetail = false
  }

}
